import * as types from 'actions/types';
export const cacheSharedBillInfo = (transactionId, activities) => ({
    type: types.CACHE_SHARED_BILL_INFO,
    payload: {
        id: transactionId,
        users: activities,
    },
});
export const clearSharedBillInfoCache = (transactionId) => ({
    type: types.CLEAR_SHARED_BILL_INFO_CACHE,
    payload: {
        id: transactionId,
    },
});
